import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import presitentStore from "./store";
import { BrowserRouter as Router } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import theme from "./theme";
import { ThemeProvider } from "@mui/material/styles";
import { ConfirmServiceProvider } from "./Contexts/ConfirmContext/ConfirmService";
import { AlertServiceProvider } from "./Contexts/AlertContext/AlertService";
import { CssBaseline } from "@mui/material";
import { AuthProvider } from "./providers/authProvider";
import { LoadingProvider } from "./providers/loadingProvider";
import { NotificationProvider } from "./providers/NotificationProvider";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

const { store, persistor } = presitentStore;

const cache = createCache({
  key: "gif-app",
  prepend: true,
});

ReactDOM.render(
  <React.Fragment>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AuthProvider>
          <CacheProvider value={cache}>
            <ThemeProvider theme={theme}>
              <ConfirmServiceProvider>
                <AlertServiceProvider>
                  <CssBaseline />
                  <NotificationProvider>
                    <LoadingProvider>
                      <Router basename={"/"}>
                        <App />
                      </Router>
                    </LoadingProvider>
                  </NotificationProvider>
                </AlertServiceProvider>
              </ConfirmServiceProvider>
            </ThemeProvider>
          </CacheProvider>
        </AuthProvider>
      </PersistGate>
    </Provider>
  </React.Fragment>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
